import { render, staticRenderFns } from "./VetrinaConsorzio.vue?vue&type=template&id=1b744710&scoped=true"
import script from "./VetrinaConsorzio.vue?vue&type=script&lang=js"
export * from "./VetrinaConsorzio.vue?vue&type=script&lang=js"
import style0 from "./VetrinaConsorzio.vue?vue&type=style&index=0&id=1b744710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b744710",
  null
  
)

export default component.exports